module.exports = __webpack_public_path__ + "img/copying_icon.03d63c25.svg";